import { makeAutoObservable } from "mobx";
import {
    deleteObj,
    getObjById,
    pagingPatientpayment,
    saveOrUpdateObj
} from 'app/services/PaymentMethod';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";

const defaultValue = {
    code: "",
    name: "",
    isUsing: true,
    interestRateType: 1,
    interestRatePeriods: []
}
export default class PaymentMethodStore {
    searchObj = new SearchObject();
    pageObj = null;
    selectedObj = defaultValue;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    selectedRowService = null;
    constructor() {
        makeAutoObservable(this);
    }

    pagingObj = async () => {
        return await pagingPatientpayment(this.searchObj)
            .then(({ data }) => {
                this.pageObj = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu hình thức thanh toán có lỗi")
            })
    }

    setSelectedRowService = (row) => {
        this.selectedRowService = row;
    };

    handleChangeFormSearch = (searchObj) => {
        this.searchObj = checkSearchObject(this.searchObj, searchObj);
        this.pagingObj();
    }

    handleOpenFormCreateOrEdit = (medicalEquipmentId) => {
        if (Boolean(medicalEquipmentId)) {
            getObjById(medicalEquipmentId).then(({ data }) => {
                this.selectedObj = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedObj = { ...defaultValue };
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateObj = (medicalEquipment, { setSubmitting }) => {
        saveOrUpdateObj(medicalEquipment)
            .then(() => {
                this.selectedObj = defaultValue;
                toast.success("Lưu thông tin thành công!");
                this.handleClosePopup();
                this.pagingObj();
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu thông tin có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (medicalEquipment) => {
        this.selectedObj = { id: medicalEquipment?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteObj(this.selectedObj?.id)
            .then(() => {
                if (this.searchObj?.pageIndex > 1 && this.pageObj?.content?.length === 1) {
                    this.searchObj.pageIndex -= 1;
                }
                toast.success("Xóa hình thức thanh toán thành công!");
                this.handleClosePopup();
                this.pagingObj();
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa hình thức thanh toán có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchObj = new SearchObject();
        this.pageObj = null;
        this.selectedObj = defaultValue;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }




}
